export function parseStreamEmbedUrl(url: string): string {
  if (!url) return '';
  const trimmed = url.trim();

  // If already YouTube embed link
  if (trimmed.includes('youtube.com/embed/')) {
    return trimmed;
  }

  // YouTube live link: e.g. https://www.youtube.com/live/yZ7eZ8H_a1I?is=jgy0RIN_u-bmXzg1
  const youtubeLiveMatch = trimmed.match(/youtube\.com\/live\/([a-zA-Z0-9_-]+)/);
  if (youtubeLiveMatch && youtubeLiveMatch[1]) {
    return `https://www.youtube.com/embed/${youtubeLiveMatch[1]}`;
  }

  // YouTube watch link: e.g. https://www.youtube.com/watch?v=yZ7eZ8H_a1I
  const youtubeWatchMatch = trimmed.match(/youtube\.com\/watch\?(?:.*&)?v=([a-zA-Z0-9_-]+)/);
  if (youtubeWatchMatch && youtubeWatchMatch[1]) {
    return `https://www.youtube.com/embed/${youtubeWatchMatch[1]}`;
  }

  // Short YouTube link: e.g. https://youtu.be/yZ7eZ8H_a1I
  const youtubeShortMatch = trimmed.match(/youtu\.be\/([a-zA-Z0-9_-]+)/);
  if (youtubeShortMatch && youtubeShortMatch[1]) {
    return `https://www.youtube.com/embed/${youtubeShortMatch[1]}`;
  }

  // Vimeo link: e.g. https://vimeo.com/12345678
  const vimeoMatch = trimmed.match(/vimeo\.com\/([0-9]+)/);
  if (vimeoMatch && vimeoMatch[1]) {
    return `https://player.vimeo.com/video/${vimeoMatch[1]}`;
  }

  return trimmed;
}
